import { useEffect, useState } from 'react';

/**
 * `useDevice()` — shared device-class detection for onboarding screens.
 *
 * Returns one of: 'ios' | 'android' | 'desktop'.
 * Also returns `isStandalone` (already installed as a PWA) so screens
 * can skip the install step for anyone who's already there.
 *
 * We deliberately only use userAgent hints — no fingerprinting, no
 * network calls. `display-mode: standalone` is the reliable PWA
 * signal on both iOS and Android.
 */
export default function useDevice() {
  const [state, setState] = useState({ device: 'desktop', isStandalone: false });
  useEffect(() => {
    if (typeof navigator === 'undefined') return;
    const ua = (navigator.userAgent || '').toLowerCase();
    let device = 'desktop';
    if (/iphone|ipad|ipod/.test(ua) || (ua.includes('mac') && 'ontouchend' in document)) {
      device = 'ios';
    } else if (/android/.test(ua)) {
      device = 'android';
    }
    let isStandalone = false;
    try {
      isStandalone =
        window.matchMedia?.('(display-mode: standalone)')?.matches ||
        window.navigator.standalone === true;
    } catch { /* older browsers */ }
    setState({ device, isStandalone });
  }, []);
  return state;
}
